(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    

  // Define an async function to add a product to the cart
async function addToCart(variantId, quantity = 1) {
  try {
    // Make the POST request to Shopify's cart/add.js endpoint
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: variantId, // ID of the product variant to add
        quantity: quantity // Quantity of the product to add
      })
    });

    // Check if the request was successful
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    // Parse the JSON response
    const responseJson = await response.json();
    console.log('Product added to cart:', responseJson);

    document.dispatchEvent(new CustomEvent('cart:refresh'));

  } catch (error) {
    console.error('Error adding product to cart:', error);
    // Handle errors (e.g., display a message to the user)
  }
}

// Set up an event listener for the custom event
document.addEventListener('cart:refresh', () => {
    console.log("CALLED HEREEEEEEEEEEEEEEEEEEEEEE");
});



// function initializeSwiper() {
//     let swiper = new Swiper(".g-custom-cart-upsells", {
//         pagination: {
//             el: ".swiper-pagination",
//             clickable: true,
//             enabled: true
//         },
//         grabCursor: true,
//         slidesPerView: 1,
//         spaceBetween: 10,
//         breakpoints: {}
//     });
// }


$(document).ready(function() {
    // Use event delegation to handle clicks on dynamically added elements
    $(document).on("click", ".gccu--upsell-btn.gccu--available", function() {
        const id = $(this).data("vid");
        addToCart(id);
    });


    let isDragging = false;
    let startX, scrollLeft, $upsellsWrapper;

    function handleDrag(x) {
        const walk = (x - startX) * 1; // Adjust the scroll speed if needed
        $upsellsWrapper.scrollLeft(scrollLeft - walk);
    }

    function getXPosition(e) {
        // Check for touches or mouse events and return the x position
        if (e.type.startsWith('touch')) {
            return e.touches[0].pageX; // Use touches directly for touch events
        } else {
            return e.pageX; // Use pageX for mouse events
        }
    }

    function startDrag(e) {
        e.preventDefault(); // Prevent default behavior to enable custom scrolling
        isDragging = true;
        $upsellsWrapper = $(this); // Use the current element as the context
        startX = getXPosition(e) - $upsellsWrapper.offset().left;
        scrollLeft = $upsellsWrapper.scrollLeft();
        $upsellsWrapper.css('cursor', 'grabbing');
    }

    function endDrag() {
        if (isDragging) {
            isDragging = false;
            $upsellsWrapper.css('cursor', 'grab');
        }
    }

    function dragMove(e) {
        if (!isDragging) return;
        e.preventDefault(); // Prevent default behavior to enable custom scrolling
        const x = getXPosition(e) - $upsellsWrapper.offset().left;
        handleDrag(x);
    }

    // Mouse Events with jQuery
    $(document).on('mousedown', '.g-custom-cart-upsells--wrapper', startDrag);
    $(document).on('mouseleave mouseup', '.g-custom-cart-upsells--wrapper', endDrag);
    $(document).on('mousemove', '.g-custom-cart-upsells--wrapper', dragMove);
  
});

//DRAGGING
// const setupDragEvents = () => {
//   const upsellsWrapper = document.querySelector('.g-custom-cart-upsells--wrapper');
  
//   let isDragging = false;
//   let startX, scrollLeft;
  
//   function handleDrag(x) {
//       const walk = (x - startX) * 1; // Adjust the scroll speed by changing the multiplier
//       upsellsWrapper.scrollLeft = scrollLeft - walk;
//   }
  
//   function startDrag(e) {
//       isDragging = true;
//       startX = e.pageX || e.touches[0].pageX - upsellsWrapper.offsetLeft;
//       scrollLeft = upsellsWrapper.scrollLeft;
//       upsellsWrapper.style.cursor = 'grabbing';
//   }
  
//   function endDrag() {
//       isDragging = false;
//       upsellsWrapper.style.cursor = 'grab';
//   }
  
//   function dragMove(e) {
//       if (!isDragging) return;
//       e.preventDefault();
//       const x = e.pageX || e.touches[0].pageX - upsellsWrapper.offsetLeft;
//       handleDrag(x);
//   }
  
//   // Mouse Events
//   upsellsWrapper.addEventListener('mousedown', startDrag);
//   upsellsWrapper.addEventListener('mouseleave', endDrag);
//   upsellsWrapper.addEventListener('mouseup', endDrag);
//   upsellsWrapper.addEventListener('mousemove', dragMove);
  
//   // Touch Events
//   upsellsWrapper.addEventListener('touchstart', (e) => {
//       startDrag(e);
//   }, { passive: false });
  
//   upsellsWrapper.addEventListener('touchend', endDrag);
//   upsellsWrapper.addEventListener('touchmove', (e) => {
//       dragMove(e);
//   }, { passive: false });
// }



  } catch(e) { console.error(e); }
})();
})();
